// extracted by mini-css-extract-plugin
module.exports = {"input":"FormTextarea_input__FkTCc","formTextarea--error":"FormTextarea_formTextarea--error__ktb1s","rotation":"FormTextarea_rotation__gxXcj"};